import { action, observable, runInAction, makeObservable } from 'mobx';
import { request } from '@/framework/network/request'
import MenuNode from '@home/model/MenuNode'

export default class BackendStore {

  loading: boolean;
  siderMenu: Array<MenuNode>;

  constructor () {
    makeObservable(this, {
      loading: observable,
      siderMenu: observable,
      fetchSiderMenu: action
    });

    this.loading = false
    this.siderMenu = []
  }

  fetchSiderMenu = async () => {
    this.loading = true
    try {
      const res = await request.get(`/u/menu/platformMark/backend`)
      runInAction(() => {
        this.siderMenu = res.data
      })
    } catch (e) {

    }
    runInAction(() => {
      this.loading = false
    })
  };
}
